/** E-mails de paiement — les 3 cas Ninja utiles. */
import { CheckField } from "../../components/CheckField";
import type { CompanyPayments } from "../../payments/types";

type PaymentsMailProps = {
  draft: CompanyPayments;
  setDraft: (next: CompanyPayments) => void;
};

export function PaymentsMail({ draft, setDraft }: PaymentsMailProps) {
  return (
    <div className="fx-fmt-row">
      <span>E-mails</span>
      <div className="flex flex-col gap-2">
        <CheckField
          label="E-mail lors d’une saisie manuelle"
          checked={draft.email_payment_manual}
          onChange={(next) => setDraft({ ...draft, email_payment_manual: next })}
        />
        <CheckField
          label="E-mail lors d’un paiement en ligne"
          checked={draft.email_payment_online}
          onChange={(next) => setDraft({ ...draft, email_payment_online: next })}
        />
        <CheckField
          label="E-mail en marquant une facture payée"
          checked={draft.email_payment_marked}
          onChange={(next) => setDraft({ ...draft, email_payment_marked: next })}
        />
      </div>
    </div>
  );
}
